//import { useLocalizeField } from "~/l10n";

export function ExitSperrfristenNichtEingehalten() {
  //const l = useLocalizeField();

  return (
    <>
      <h2>
        Die Mieterhöhung ist nicht rechtmäßig, da die Sperrfrist nicht
        eingehalten wurde.
      </h2>
      <p>TODO</p>
      <h3>Was nun?</h3>
      <p></p>
    </>
  );
}
